import React from 'react';
import {Link} from 'react-router-dom';
import {Container,Button, Row, Col} from 'react-bootstrap';
import PropTypes from 'prop-types';
import { Search } from 'react-feather';
import AccordionFAQ from '../components/telescope/AccordionFAQ';

import { IdTokenData } from '../components/ms-entra/DataDisplay';

const styles = {
  container: {
    background: 'linear-gradient(90deg, rgba(83,108,48,1) 0%, rgba(45,46,70,1) 25%, rgba(45,46,70,1) 100%)',
    color: 'white',
    paddingLeft: '10%',
    paddingTop: '4%',
    paddingBottom: '4%',
    borderRadius: '0 0 10px 10px',
    border: 'none',
  },
  containerLightBackground: {
    paddingLeft: '10%',
    paddingTop: '4%',
    paddingBottom: '4%',
    borderRadius: '10px',
    backgroundColor: 'rgb(245, 245, 245)',
  },
  containerNoBackground: {
    paddingLeft: '10%',
    paddingTop: '4%',
    paddingBottom: '4%',
    borderRadius: '10px',
  },
  colorred: {
    color: 'red',
    fontWeight: 'lighter',
  },
  colorwhite: {
    color: 'white',
    fontWeight: 'lighter',
  },
  backgroundColorTelescopeGreen: {
    backgroundColor: 'rgb(84, 115, 76)',
  },
};

const AuthenticatedLandingPage = ({ message }) => {
  
  return (
    <>

      <Col style={styles.container} lg={12}>
          <Row >
            <Col lg={6}>
                <h1 className="display-5" style={styles.colorwhite}>Scout for Suppliers</h1>
                <p>De-risk your supply chain by finding the best supplier that fits your needs.</p>
                <br />
                {/* <Link to="/suppliers/search?endpoint=vector" className="navbar-brand me-0">
                    <Button size="lg" >
                        Go to Supplier Search (Vector)
                    </Button>
                </Link>
                &nbsp;&nbsp; */}
                <Link to="/suppliers/search" className="navbar-brand me-0">
                    <Button size="lg" >
                        Go to Supplier Search
                    </Button>
                </Link>
            </Col>
            <Col lg={6}>
                <h1 className="display-5" style={styles.colorwhite}>Sourcing Projects</h1>
                <p>Manage the materials you are sourcing, and the suppliers you are evaluating.</p>
                <br />
                <Link to="/projects/sourcing/detail" className="navbar-brand me-0">
                  <Button size="lg" className="btn btn-primary btn-lg" >
                      Go to Sourcing Projects
                  </Button>
                </Link>
            </Col>
          </Row>
      </Col>
      <Col style={styles.containerLightBackground} lg={12}>
          <Row>
            <Col lg={6}>
                <h1 className="display-5" >
                  Find New Opportunities
                </h1>
                <p>Discover contracts and grants to grow your business.</p>
                <br />
                <Link to="/opportunities/reset" className="navbar-brand me-0">
                  <Button size="lg" className="btn btn-primary btn-lg" style={styles.backgroundColorTelescopeGreen} >
                      Go to Opportunity Search
                  </Button>
                </Link>
                </Col>
            <Col lg={6}>
                <h1 className="display-5" >
                  Opportunity Projects
                </h1>
                <p>View and manage your saved opportunities.</p>
                <br />
                <Link to="/projects/opportunities/cards" className="navbar-brand me-0">
                  <Button size="lg" className="btn btn-primary btn-lg" style={styles.backgroundColorTelescopeGreen} >
                      Go to Opportunity Projects
                  </Button>
                </Link>
            </Col>
          </Row>
      </Col>


    </>
  );
};

AuthenticatedLandingPage.propTypes = {
  message: PropTypes.string,
};


AuthenticatedLandingPage.defaultProps = {
  message: 'Feature not available',
};

export default AuthenticatedLandingPage;